import SEO from '../../../components/SEO';
import MoringaProductHero from './components/MoringaProductHero';
import MoringaSizes from './components/MoringaSizes';
import MoringaKeyBenefits from './components/MoringaKeyBenefits';
import MoringaNutrition from '../components/MoringaNutrition';
import MoringaFAQ from '../components/MoringaFAQ';
import MoringaTestimonials from '../components/MoringaTestimonials';

export default function MoringaPowderProduct() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  const productUrl = `${siteUrl}/products/moringa-powder`;
  const paystackUrl = 'https://paystack.shop/pay/v9-4hu3n50';
  const productImage = 'https://public.readdy.ai/ai/img_res/edited_e17d2c62eadfd03030c4db97e8f52ea6_45dfadd7.jpg';

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Product',
        name: 'Pure Moringa Powder — MY AVA Farms Ghana',
        description:
          '100% pure moringa leaf powder grown and processed in Ghana. Rich in iron, calcium, vitamin C, and antioxidants. No additives, no fillers, no preservatives. Slow-dried at low heat to protect nutrients. Available in 50g, 100g, 250g, and 1kg packs with nationwide delivery across Ghana.',
        url: productUrl,
        brand: {
          '@type': 'Brand',
          name: 'MY AVA Farms',
          url: siteUrl,
        },
        image: [
          productImage,
          'https://public.readdy.ai/ai/img_res/394f516a6827ca02ee7e5f614a522f56.jpg',
        ],
        sku: 'MYAVA-MORINGA',
        mpn: 'MORINGA-POWDER-GH',
        category: 'Health Supplements / Superfoods',
        countryOfOrigin: 'GH',
        material: '100% Dried Moringa Leaf',
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5.0',
          reviewCount: '6',
          bestRating: '5',
          worstRating: '1',
        },
        review: [
          {
            '@type': 'Review',
            reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
            author: { '@type': 'Person', name: 'Abena Mensah' },
            reviewBody: 'My energy levels have completely changed. I take 2 teaspoons every morning — the difference in my afternoon energy is remarkable.',
          },
          {
            '@type': 'Review',
            reviewRating: { '@type': 'Rating', ratingValue: '5', bestRating: '5' },
            author: { '@type': 'Person', name: 'Kwame Asante' },
            reviewBody: 'After 2 months of daily use my haemoglobin levels improved significantly. My doctor was impressed. This is clearly the real thing.',
          },
        ],
        offers: [
          {
            '@type': 'Offer',
            name: 'Pure Moringa Powder 50g',
            price: '20',
            priceCurrency: 'GHS',
            availability: 'https://schema.org/InStock',
            url: paystackUrl,
            itemCondition: 'https://schema.org/NewCondition',
            seller: { '@type': 'Organization', name: 'MY AVA Farms' },
            shippingDetails: {
              '@type': 'OfferShippingDetails',
              shippingDestination: { '@type': 'DefinedRegion', addressCountry: 'GH' },
            },
          },
          {
            '@type': 'Offer',
            name: 'Pure Moringa Powder 100g',
            price: '35',
            priceCurrency: 'GHS',
            availability: 'https://schema.org/InStock',
            url: paystackUrl,
            itemCondition: 'https://schema.org/NewCondition',
            seller: { '@type': 'Organization', name: 'MY AVA Farms' },
          },
          {
            '@type': 'Offer',
            name: 'Pure Moringa Powder 250g',
            price: '75',
            priceCurrency: 'GHS',
            availability: 'https://schema.org/InStock',
            url: paystackUrl,
            itemCondition: 'https://schema.org/NewCondition',
            seller: { '@type': 'Organization', name: 'MY AVA Farms' },
          },
          {
            '@type': 'Offer',
            name: 'Pure Moringa Powder 1kg',
            price: '250',
            priceCurrency: 'GHS',
            availability: 'https://schema.org/InStock',
            url: paystackUrl,
            itemCondition: 'https://schema.org/NewCondition',
            seller: { '@type': 'Organization', name: 'MY AVA Farms' },
          },
        ],
        additionalProperty: [
          { '@type': 'PropertyValue', name: 'Shelf Life', value: '24 months' },
          { '@type': 'PropertyValue', name: 'Processing Method', value: 'Low-heat dried below 60°C' },
          { '@type': 'PropertyValue', name: 'Country of Origin', value: 'Ghana' },
          { '@type': 'PropertyValue', name: 'Additives', value: 'None' },
          { '@type': 'PropertyValue', name: 'Suitable For', value: 'Adults, Children over 1 year, Elderly' },
        ],
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Products', item: `${siteUrl}/products` },
          { '@type': 'ListItem', position: 3, name: 'Pure Moringa Powder', item: productUrl },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is the recommended daily dosage of moringa powder?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'For adults, 1–2 teaspoons (3–6g) per day. Start with ½ teaspoon and increase gradually. Best taken in the morning in warm water, a smoothie, or porridge. Do not exceed 2 tablespoons (10g) per day.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is moringa powder safe for children?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes. Children aged 1–5 can take ¼ teaspoon (1g) per day; children 6–12 can take ½ teaspoon. Particularly beneficial for bone development, healthy blood, and eyesight.',
            },
          },
          {
            '@type': 'Question',
            name: 'How do I store moringa powder?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Store in a sealed, airtight container away from direct sunlight, heat, and moisture. No refrigeration needed. Shelf life is 24 months when stored correctly.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is this moringa powder 100% pure with no additives?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes — one ingredient: moringa leaves. No fillers, additives, preservatives, artificial colours, flavours, or added sugar. Grown in Ghana without synthetic pesticides.',
            },
          },
          {
            '@type': 'Question',
            name: 'How soon will I feel the health benefits?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Most people notice improved energy within 1–2 weeks. Immunity, iron levels, and longer-term benefits typically show after 4–8 weeks of consistent daily use.',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title="Pure Moringa Powder Ghana — Buy 50g 100g 250g 1kg | MY AVA Farms Accra"
        description="Buy 100% pure moringa powder grown in Ghana. No additives, low-heat processed, rich in iron, calcium & vitamin C. Available in 50g, 100g, 250g, 1kg. Nationwide delivery. Trusted by buyers across Ghana — order via Paystack."
        keywords="pure moringa powder Ghana, buy moringa powder Accra, moringa powder price Ghana, organic moringa powder, moringa leaf powder, moringa 100g Ghana, moringa benefits Ghana, MY AVA Farms moringa"
        ogImage={productImage}
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <MoringaProductHero />
        <MoringaSizes />
        <MoringaKeyBenefits />
        <MoringaNutrition />
        <MoringaFAQ />
        <MoringaTestimonials />

        {/* Final sticky-style CTA banner */}
        <section className="py-20 bg-gray-900 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to start your moringa journey?
            </h2>
            <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">
              Join hundreds of Ghanaians who have made pure moringa powder part of their daily routine. Order now and get nationwide delivery straight to your door.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href={paystackUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-green-500 hover:bg-green-400 text-white font-bold px-10 py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap text-lg"
              >
                <i className="ri-shopping-bag-line mr-2 text-xl"></i>
                Order via Paystack
              </a>
              <a
                href="/contact"
                className="inline-flex items-center border-2 border-gray-600 text-gray-300 hover:border-white hover:text-white font-semibold px-8 py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                Call +233 23 337 1378
              </a>
            </div>
            <p className="text-xs text-gray-500 mt-6">
              Secure payment via Paystack · Available in 50g, 100g, 250g &amp; 1kg · Grown &amp; processed in Ghana
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
